import { RelationshipTableConfig } from '../../../app/config/model/relationship-config.model';

export const RELATIONSHIP_TABLE_CONFIG: RelationshipTableConfig = {
  relationshipInfos: [
   /* {
      fkArbeitsbereich: 'altlasten',
      fkIdentifyLayerId: 2,
      tables: [
        {
          id: 'projekt',
          title: 'JSON_CONFIG.RELATIONSHIP_TABLES.PROJEKTE_TITLE',
          icon: 'work',
          deleteConfirmModalKey: 'MODAL.CONFIRM.DELETE_PROJEKT',
          cannotDeleteConfirmModalKey: 'MODAL.CONFIRM.CANNOT_DELETE_PROJEKT',
          unlinkConfirmModalKey: 'MODAL.CONFIRM.UNLINK_PROJEKT',
          searchField: 'NAME',
          displayField: 'NAME',
          relationshipId: 2,
          formFields: [
            {
              NUMMER: 'Projektnummer',
              editable: true,
              required: true,
              max_length: 10,
              min_length: 4,
            },
            {
              NAME: 'Bezeichnung',
              editable: true,
              required: true,
              max_length: 150,
            },
            {
              BEMERKUNGEN: 'Bemerkungen',
              editable: true,
              required: false,
              max_length: 1000,
            },
            {
              REGION: 'Region',
              editable: true,
              component: 'selectbox',
            },
            {
              KANTONKOSTEN: 'Kostenteiler',
              editable: true,
              component: 'selectbox',
            },
          ],
        },
        {
          id: 'pendenz',
          title: 'JSON_CONFIG.RELATIONSHIP_TABLES.PENDENZEN_TITLE',
          icon: 'schedule',
          deleteConfirmModalKey: 'MODAL.CONFIRM.DELETE_PENDENZ',
          displayField: 'OBJECTID',
          relationshipId: 1,
          formFields: [
            {
              PENDENZERFASSTAM: 'Erfasst am',
              editable: true,
              required: false,
              component: 'datepicker',
            },
            {
              FAELLIGKEITSDATUM: 'Fälligkeitsdatum',
              editable: true,
              required: false,
              component: 'datepicker',
            },
            {
              VERANTWORTLICH: 'Verantwortlicher',
              editable: true,
              required: false,
              component: 'typeaheadbox',
              searchField: 'VERANTWORTLICH',
            },
            {
              ERLEDIGT: 'Erledigt',
              editable: true,
              required: false,
              component: 'checkbox',
            },
            {
              PENDENZENTYP: 'Pendenz',
              editable: true,
              required: false,
              component: 'selectbox',
            },
            {
              BEMERKUNG: 'freier Text',
              editable: true,
              required: false,
            },
          ],
        },
      ],
    },*/
  ],
  linienName: {
    tableId: 'me_os_linie_view',
    linienFieldName: 'LINIENNAME',
  },
};
